module.exports = __webpack_public_path__ + "img/copy.3a1be9b7.svg";